import * as Yup from 'yup';

export const validationSchema = () => {
  let schema = Yup.object();
  schema = schema.shape({
    isVerified: Yup.boolean(),

    smsField: Yup.string()
      .transform((val) => (val || '').trim())
      .nullable()
      .when('isVerified', {
        is: true,
        then: (schema) => schema.required('Nội dung tin nhắn phải có'),
        otherwise: (schema) => schema.nullable(),
      }),
    });
  return schema;
};

export const handleSubmitted = async (values, item, apiSendBill, apiSendTicket, apiUnsendTicket) => {  
  let myId = 0;
  if (item != null && (Object.keys(item).length > 0 || item.constructor !== Object)) {
    myId = item.id;
  }
  if(0 === myId) return;
  const ticketId = item.ticket?.id;

  if(values.isVerified){
    const json = {
      userId: item.contact?.id,
      paymentId: item.payment?.id,
      reason: values.smsField,
      sourceId: myId
    };
    await apiSendTicket(json);
  }else{
    if(ticketId > 0){
      const json = {
        ticketId: ticketId,
        userId: item.contact?.id,
        paymentId: item.payment?.id,
        sourceId: myId
      };
      await apiUnsendTicket(json);
    }else{
      const json = {
        moduleType: 0,
        amount: item.price,
        sourceId: myId
      }
      await apiSendBill(json);
    }
  }
};
